<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a button that allows the user to add the app to the homepage of their phone
    *
    * @since 20210423
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2021 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span>
        <span v-if="shouldDisplay">
            <button v-if="!addedToHomePage && saving" class="btn btn-info"><i class="fas fa-sync fa-spin"></i> Add App Shortcut</button>
            <button v-else-if="!addedToHomePage" class="btn btn-info" @click="install()"><i class="fas fa-home"></i> Add App Shortcut</button>
        </span>
        <span v-if="isThisDeviceRunningiOS() && !installed">
            <div class="modal fade" id="add_to_homepage_ios_modal" role="dialog">
                <div class="modal-dialog">       
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Add App Shortcut</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            We recommend adding the app as a shortcut on your homescreen to make it easier to access. You can do this by:<br /><br />
                            <ul>
                                <li>Tapping on <img src="https://16eb5145b023956a62dd-e9ffdf57af9333ae295d6fff988d3a78.ssl.cf3.rackcdn.com/iosInstall.png"></li>
                                <li>Then selecting 'Add to Homescreen' and follow any prompts that follow</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn btn-info" @click="showIOSModal()"><i class="fas fa-home"></i> Add App Shortcut</button>
        </span>
    </span>
</template>

<script>
    export default{
        props: {
        },
        created() {
            var self = this;
            window.addEventListener('beforeinstallprompt', (e) => {
                // Prevent Chrome 67 and earlier from automatically showing the prompt
                e.preventDefault();
                // Stash the event so it can be triggered later.
                self.deferredPrompt = e;
                // Update UI to notify the user they can add to home screen
                self.shouldDisplay = true;
                
                console.log('Before prompt install');
            });
            this.isInstalled();
        },
        beforeDestroy() {
            window.removeEventListener('beforeinstallprompt');
        },
        data() {
            return {
                deferredPrompt: null,
                shouldDisplay: false,
                saving: false,
                addedToHomePage: false,
                installed: true
            }
        },
        computed: {
        },
        methods: {
            install: function(){
                this.saving = true;
                var self = this;
                // Show the prompt
                self.deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                self.deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        self.saving = false;
                        self.addedToHomePage = true;
                    } else {
                        
                    }
                    self.deferredPrompt = null;
                }).catch((error) => {
                    console.log('An error occurred loading the user choice');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                });
                
            },
            showIOSModal: function(){
                $('#add_to_homepage_ios_modal').modal('show');
            },
            isThisDeviceRunningiOS: function (){
                if (['iPad Simulator', 'iPhone Simulator','iPod Simulator', 'iPad','iPhone','iPod'].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)){
                    return true;
                } else {
                    return false;
                }
            },
            isInstalled: async function (){
                if ('getInstalledRelatedApps' in window.navigator) {
                    let relatedApps = await window.navigator.getInstalledRelatedApps();
                    if (relatedApps.length > 0){
                        this.installed = true;
                    } else {
                        this.installed = false;
                    }
                } else {
                    this.installed = (('standalone' in window.navigator) && (window.navigator.standalone));
                }
            }
        }
    }
</script>